import { initializeStep3 } from '../config-step-3/config-step-3.js'; 

const configWrapper = document.querySelector('.config-page-wrapper');
const resultBtns = document.querySelectorAll('.result-btn-mobile');
const resultProductMobiles = document.querySelectorAll('.result-product-mobile');
const brandElements = document.querySelectorAll('.brand-elements .brand-element');
const quantitySwitches = document.querySelectorAll('.swiper-pagination-switch');
const select = document.querySelector('.quantity-select');

select.addEventListener('change', () => {
    const val = document.querySelector('.quantity-select').value;
    quantitySwitches.forEach((el) => {
        if(el.getAttribute('data-unit') == val) {
            el.classList.add('active');
        } else {
            el.classList.remove('active')
        }
    })
})

resultBtns.forEach((resultBtn, index) => {
    const resultProductMobile = resultProductMobiles[index];
    const closeResult = resultProductMobile.querySelector('.close-wrapper');

    if (resultBtn && resultProductMobile && closeResult) {
        resultBtn.addEventListener('click', () => {
            resultProductMobile.classList.toggle('active');
            resultBtn.classList.toggle('active');
            configWrapper.classList.toggle('active');
        });

        closeResult.addEventListener('click', () => {
            resultProductMobile.classList.remove('active');
            resultBtn.classList.remove('active');
            configWrapper.classList.remove('active');
        });

        document.addEventListener('click', (event) => {
            const targetElement = event.target;
            const dropdownClicked = targetElement.closest('.result-btn-mobile');
            const dropdownContent = targetElement.closest('.result-product-mobile');

            if (!dropdownClicked && !dropdownContent) {
                resultProductMobile.classList.remove('active');
                resultBtn.classList.remove('active');
                configWrapper.classList.remove('active');
            }
        });
    }
});

brandElements.forEach(brandelement => {
    brandelement.addEventListener('click', () => {
        brandElements.forEach(sub => {
            sub.classList.remove('active');
        });
        brandelement.classList.add('active');
        toggleSwitches();
        const currentActiveIndex = [...quantitySwitches].findIndex(switchElement => switchElement.classList.contains('active'));
        if (currentActiveIndex < 0) {
            activateSwitch(0);

        }
        if (brandelement.classList.contains('right-element')) {

            if (currentActiveIndex < 2) {
                const newLeft = '66%';
                document.documentElement.style.setProperty('--selectQuantity', newLeft);
                activateSwitch(2);
                qualityHandler.style.left = newLeft;

            }

        }

    });
});

// function activateSwitch(index) {
//     quantitySwitches.forEach((switchElement, i) => {
//         if (i === index) {
//             switchElement.classList.add('active');
//         } else {
//             switchElement.classList.remove('active');
//         }
//     });
// }


function activateSwitch(index) {
    quantitySwitches.forEach((switchElement, i) => {
        switchElement.classList.toggle('active', i === index);
    });
}
activateSwitch(0);

quantitySwitches.forEach((switchElement, index) => {
    switchElement.addEventListener('click', () => {
        const leftElement = document.querySelector('.brand-element.left-element');
        const rightElement = document.querySelector('.brand-element.right-element');
        const widthPerStep = 100 / (quantitySwitches.length - 1);

        if (leftElement.classList.contains('active')) {
            const newLeft = `${widthPerStep * index}%`;
            qualityHandler.style.left = newLeft;
        } else if (rightElement.classList.contains('active')) {
            if (index > 1) {
                const newLeft = `${(index === 2) ? 66 : 99}%`;
                qualityHandler.style.left = newLeft;

            } else {
                return;
            }
        }

        activateSwitch(index);
    });
});


function toggleSwitches() {
    const leftElement = document.querySelector('.brand-element.left-element');
    const rightElement = document.querySelector('.brand-element.right-element');
    quantitySwitches.forEach((switchElement, index) => {
        if (leftElement.classList.contains('active')) {
            switchElement.classList.remove('disabled');
            select.querySelectorAll('option').forEach((el, i) => {
                el.removeAttribute('disabled');
            })
        } else if (rightElement.classList.contains('active')) {
            switchElement.classList.toggle('disabled', index < 2);
            select.querySelectorAll('option').forEach((el, i) => {
                if(i < 2) {
                    el.setAttribute('disabled', 'disabled');
                }
            });
            if(parseInt(select.value) < 5001) {
                select.value = 10000;
            }
        }
    });
}


const qualityHandler = document.querySelector('.quantity-wrapper .draggable-handle');
const qualityProgressBar = document.querySelector('.quantity-wrapper .swiper-pagination-quantity');

let isDragging = false;
let startX;
let startLeft;

if (qualityHandler) {

    qualityHandler.addEventListener('mousedown', function (event) {
        isDragging = true;
        startX = event.clientX;
        startLeft = parseFloat(getComputedStyle(qualityHandler).left);
    });

    const rightElement = document.querySelector('.brand-element.right-element');

    document.addEventListener('mousemove', function (event) {
        if (isDragging && qualityProgressBar) {
            const qualityProgressBarWidth = qualityProgressBar.offsetWidth;
            const handleWidth = qualityHandler.offsetWidth;
            const deltaX = event.clientX - startX;
            let newLeft = startLeft + deltaX;

            if (rightElement.classList.contains('active')) {
                const minLeft = 66 * (qualityProgressBarWidth / 100);
                newLeft = Math.max(minLeft, Math.min(newLeft, qualityProgressBarWidth - handleWidth));
            } else {
                newLeft = Math.max(0, Math.min(newLeft, qualityProgressBarWidth - handleWidth));
            }

            qualityHandler.style.left = newLeft + 'px';
            updateQuantity(newLeft / qualityProgressBarWidth);
        }
    });

    document.addEventListener('mouseup', function () {
        isDragging = false;
    });

    function updateQuantity(progress) {
        const switchCount = quantitySwitches.length;
        const index = Math.round(progress * (switchCount - 1));
        const activeSwitch = quantitySwitches[index];
        activeSwitch.click();
    }


    const nextBtnSecondStep = document.querySelector('.second-step-wrapper .next-btn');

    nextBtnSecondStep.addEventListener('click', () => {
        const mergedData = {};
    
        const selectedDataStep2 = {
            selectedBrand: null,
            selectedQuantity: null
        };
    
        const brandElementLeft = document.querySelector('.brand-element.left-element');
        const brandElementRight = document.querySelector('.brand-element.right-element');
        const quantitySwitches = document.querySelectorAll('.swiper-pagination-switch');

        if (brandElementLeft.classList.contains('active')) {
            selectedDataStep2.selectedBrand = 'gustibus';
        } else if (brandElementRight.classList.contains('active')) {
            selectedDataStep2.selectedBrand = 'private';
        }
    
        quantitySwitches.forEach((switchElement, index) => {
            if (switchElement.classList.contains('active')) {
                let quantityText = switchElement.querySelector('.switch-title').textContent.trim();
                // let quantityParts = quantityText.split('/');
                selectedDataStep2.selectedQuantity = quantityText;
            }
        });
    
        mergedData.selectedCategory = window.mergedData.selectedCategory;
        mergedData.selectedSubcategory = window.mergedData.selectedSubcategory;
        mergedData.selectedGroup = window.mergedData.selectedGroup;
        mergedData.selectedBrand = selectedDataStep2.selectedBrand;
        mergedData.selectedQuantity = selectedDataStep2.selectedQuantity;
        mergedData.selectedFormat = null;
    
        window.mergedData = mergedData;

        initializeStep3();
        
    });
}